export const getTranslatedText = (text, withParagraph = true) => {

    if(!text){
        return text;
    }

    let languageKey = localStorage.getItem('grabalo-user-language');
    let initialSearchPattern = "[" + languageKey + "]";
    let endSearchPattern = "[/" + languageKey + "]";

    if (withParagraph){
         initialSearchPattern = "<p>[" + languageKey + "]</p>";
         endSearchPattern = "<p>[/" + languageKey + "]</p>";
    }

    text = text.replace('dir="ltr"', ''); // remove **dir="ltr"** attribute as it causes bad behavior

    // console.info('languageKey -> ', languageKey)

    if (languageKey === 'vlc'){
        // let positionStart = text.indexOf(initialSearchPattern) + initialSearchPattern.length;
        let positionStart = text.indexOf(initialSearchPattern);

        let positionEnd = text.indexOf(endSearchPattern);

        if (positionStart !== -1 && positionEnd !== -1) {
            // console.log('start -> ', positionStart);
            // console.log('end -> ', positionEnd);
            // console.log('text -> ', text.slice(positionStart, positionEnd));
            text = text.slice(positionStart, positionEnd);
        }

    } else {
        let positionStart = text.indexOf('[vlc]');
        let positionEnd = text.indexOf('[/vlc]');
            // + '[/vlc]'.length;

        if (positionStart !== -1 && text.indexOf('[/vlc]') !== -1){
            text = text.replace(text.slice(positionStart, positionEnd), '');

        }
        // console.log('start -> ', positionStart);
        // console.log('end -> ', positionEnd);
        // console.log('text replaced -> ', text.replace(text.slice(positionStart, positionEnd), ''));

    }

    if (languageKey === 'esp'){
        // let positionStart = text.indexOf(initialSearchPattern) + initialSearchPattern.length;
        let positionStart = text.indexOf(initialSearchPattern);
        let positionEnd = text.indexOf(endSearchPattern);

        if (positionStart !== -1 && positionEnd !== -1) {
            // console.log('start -> ', positionStart);
            // console.log('end -> ', positionEnd);
            // console.log('text -> ', text.slice(positionStart, positionEnd));
            text = text.slice(positionStart, positionEnd);
        }
    } else {
            let positionStart = text.indexOf('[esp]');
            let positionEnd = text.indexOf('[/esp]')
                // + '[/esp]'.length;

            if (positionStart !== -1 && text.indexOf('[/esp]') !== -1){
                text = text.replace(text.slice(positionStart, positionEnd), '');

            }

    }

    // console.log('text -> ', text);

    text = text.replace('[vlc]', '');
    text = text.replace('[/vlc]', '');
    text = text.replace('[esp]', '');
    text = text.replace('[/esp]', '');


    return text;

}
